/**
 * Reloads the Feefo script element
 * @returns {Promise} - a promise that resolves when the script is loaded
 */
function reloadFeefo() {
    var feefoScript = document.getElementById('feefoScript');
    if (!feefoScript) {
        return Promise.resolve();
    }

    var newFeefoScript = document.createElement('script');

    newFeefoScript.id = feefoScript.id;
    newFeefoScript.type = feefoScript.type;
    feefoScript.parentNode.replaceChild(newFeefoScript, feefoScript);
    newFeefoScript.src = feefoScript.src;

    return new Promise((resolve) => {
        newFeefoScript.addEventListener('load', resolve);
        newFeefoScript.addEventListener('error', resolve);
    });
}

module.exports = {reloadFeefo: reloadFeefo};
